import * as Sentry from "@sentry/react"

import { error_to_string } from "core/error_to_string"
import { is_on_ajamesphillips } from "./utils/is_on_localhost"


const dsn = is_on_ajamesphillips()
    ? "https://47b67060e47e25ee4ed932823a2f6f8e@o4511203622584320.ingest.de.sentry.io/4511707352137808"
    : "https://ca1654477f20d4038ce643cb9be15902@o4511203622584320.ingest.de.sentry.io/4511252107886672"

export function setup_error_logging()
{
    Sentry.init({
        //
        dsn,
        integrations: [Sentry.browserTracingIntegration()],
        // Setting this option to true will send default PII data to Sentry.
        // For example, automatic IP address collection on events
        sendDefaultPii: true,
        enabled: window.location.hostname !== "localhost",
        tracePropagationTargets: [
            "localhost", // For local development
            "wikisim.org",
            "ajamesphillips.com",
        ],
        // Enable logs to be sent to Sentry
        enableLogs: true
    })


    const original_console_error = console.error
    const original_console_warn = console.warn
    const original_console_info = console.info

    console.error = function (...args)
    {
        if (args[0] instanceof Error) Sentry.captureException(args[0])
        else Sentry.captureMessage(args.map(error_to_string).join(" "), "error")

        // Log to the console
        original_console_error.apply(console, args)
    }

    console.warn = function (...args)
    {
        Sentry.captureMessage(args.map(error_to_string).join(" "), "warning")

        // Log to the console
        original_console_warn.apply(console, args)
    }

    console.info = function (...args)
    {
        Sentry.captureMessage(args.map(error_to_string).join(" "), "info")

        // Log to the console
        original_console_info.apply(console, args)
    }
}
